import { Component } from '@angular/core';

@Component({
  selector: 'app-crm-custom-page5',
  templateUrl: './crm-custom-page5.component.html',
  styleUrls: ['./crm-custom-page5.component.css']
})
export class CrmCustomPage5Component {

}
